// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2DEf7","col":"styles_col__krVCL"};